//
//
//
//

import { marked } from 'marked'

export default {
  props: {
    content: {
      type: String,
      required: true
    },
    isMarkdown: {
      type: Boolean,
      required: false,
      default: false
    }
  },
  computed: {
    html() {
      if (this.isMarkdown) {
        return marked.parse(this.content)
      }

      return this.content
    }
  },
  mounted() {
    const h1Elements = this.$refs.content.querySelectorAll('h1')

    h1Elements.forEach((h1Element) => {
      const h2Element = document.createElement('h2')
      h2Element.textContent = h1Element.textContent
      h2Element.classList.add('h1')
      h1Element.parentNode.replaceChild(h2Element, h1Element)
    })
  }
}
